/** A trip in this opening clause dates the following memory; it is not its parent. */
export function parseTripTemporalAnchor(text: string) {
  const match = /^\s*after\s+(?:our|my|the)\s+(?:trip|vacation)\s+to\s+([A-Z][A-Za-z .'-]{1,60}?)\s*,\s*(.+)$/i.exec(text.trim())
  if (!match) return null
  const destination = match[1].trim()
  const activity = match[2].trim()
  if (!destination || !activity || !/^(?:i|we|my|our)\b/i.test(activity)) return null
  if (/\b(?:19|20)\d{2}\b|\b(?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:tember)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)\s+\d{1,2}\b/i.test(activity)) return null
  return { destination, activity, sourceText: match[0].slice(0, match[0].indexOf(',')) }
}

export function matchesTripCandidate(title: string | null, destination: string) {
  if (!title) return false
  const clean = (value: string) => value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim()
  const place = clean(destination)
  const name = clean(title)
  const words = name.split(' ')
  return words.some(word => word === 'trip' || word === 'vacation') &&
    (` ${name} `).includes(` ${place} `)
}
